export function appointmentPatientId(item: Record<string, any> | null | undefined): string | null {
  const raw = item?.patientId;
  if (!raw) return null;
  if (typeof raw === "string") {
    const id = raw.trim();
    return id || null;
  }
  if (typeof raw === "object" && raw._id != null) {
    const id = String(raw._id).trim();
    return id || null;
  }
  return null;
}

export type OpenPatientSummaryOptions = {
  tokenNo?: string | number | null;
  queueGeneratedAt?: string | Date | null;
  appointmentId?: string | null;
};

export function openPatientSummaryInNewTab(
  patientId?: string | null,
  options?: OpenPatientSummaryOptions
) {
  const id = String(patientId ?? "").trim();
  if (!id) return;

  const params = new URLSearchParams();
  const token =
    options?.tokenNo != null && String(options.tokenNo).trim() !== ""
      ? String(options.tokenNo).trim()
      : "";
  if (token && Number(token) > 0) {
    params.set("token", token);
  }
  if (options?.queueGeneratedAt) {
    const at =
      options.queueGeneratedAt instanceof Date
        ? options.queueGeneratedAt.toISOString()
        : String(options.queueGeneratedAt);
    if (at.trim()) params.set("tokenAt", at.trim());
  } else if (token && Number(token) > 0) {
    params.set("tokenAt", new Date().toISOString());
  }

  const appointmentId = String(options?.appointmentId ?? "").trim();
  if (appointmentId) {
    params.set("appointmentId", appointmentId);
  }

  const qs = params.toString();
  const url = `${window.location.origin}/client/patient-summary/${encodeURIComponent(id)}${
    qs ? `?${qs}` : ""
  }`;
  window.open(url, "_blank", "noopener,noreferrer");
}

/** Prefer appointment token fields when opening the summary from a row. */
export function tokenInfoFromAppointment(
  item: Record<string, any> | null | undefined,
  queueOverride?: string | number | null
): { tokenNo: number; queueGeneratedAt: string | Date | null } | null {
  const queue =
    queueOverride != null && String(queueOverride).trim() !== ""
      ? queueOverride
      : item?.queue;
  if (queue == null || queue === "" || !(Number(queue) > 0)) return null;
  return {
    tokenNo: Number(queue),
    queueGeneratedAt: item?.queueGeneratedAt ?? new Date(),
  };
}

export function openPatientSummaryFromAppointment(
  item: Record<string, any> | null | undefined,
  queueOverride?: string | number | null
) {
  const patientId = appointmentPatientId(item);
  if (!patientId) return;
  const tokenInfo = tokenInfoFromAppointment(item, queueOverride);
  const appointmentId =
    item?._id != null && String(item._id).trim() !== ""
      ? String(item._id).trim()
      : null;
  openPatientSummaryInNewTab(patientId, {
    ...(tokenInfo
      ? {
          tokenNo: tokenInfo.tokenNo,
          queueGeneratedAt: tokenInfo.queueGeneratedAt,
        }
      : {}),
    ...(appointmentId ? { appointmentId } : {}),
  });
}
